import Head from "next/head";
import {generateTitle} from "../helpers/meta";
import {useRouter} from "next/router";
import localized from "../locale/locales";
import Embed from "../components/Embed";
import {useEffect} from "react";


function getForm(locale) {
    switch (locale) {
        case 'cs':
            return 'https://form.typeform.com/to/BKhdBYUH';
        case 'es':
            return 'https://form.typeform.com/to/g08oxa5D';
        case 'pl':
            return 'https://form.typeform.com/to/xRY86wac';
        case 'ro':
            return 'https://form.typeform.com/to/o78kmQQX';
        case 'en':
        default:
            return '';
        // return 'https://r54y2u3ick3.typeform.com/to/q5E3CQgi';
    }
}

export default function Register() {
    const router = useRouter();
    const {locale} = router;
    const {register: lang} = localized[locale];

    useEffect(() => {
        if (locale === 'en') {
            router.push('/', '/');
        }
    }, [locale, router]);


    return (
        <>
            <Head>
                <title key="title">{generateTitle(lang.og.title)}</title>
                <meta key="og:title" property="og:title" content={generateTitle(lang.og.title)}/>
            </Head>

            <Embed url={getForm(locale)}/>
        </>
    )
}
